import {
  CreatePasswordType,
  RecoverPasswordResponseType,
  RecoverPasswordType,
  ResetPasswordType,
  UserType,
  VerifyInvitationResponseType,
  VerifyInvitationType,
} from "@@types/IUser";
import { api } from "@services/apiClient";

export async function fetchMe(): Promise<UserType> {
  const { data } = await api.get("/users/me");
  return data;
}

export async function verifyInvitation(form: VerifyInvitationType): Promise<VerifyInvitationResponseType> {
  const { data } = await api.get(`/invitation/verify/${form.inviteCode}`);
  return data;
}

export async function resetPassword(resetPasswordForm: ResetPasswordType) {
  const resp = api.post("/users/reset-password", resetPasswordForm, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return resp;
}

export async function createPassword(createPasswordForm: CreatePasswordType) {
  const resp = api.post("/users/create-password", createPasswordForm, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return resp;
}

export async function sendRecoverPasswordEmail(form: RecoverPasswordType): Promise<RecoverPasswordResponseType> {
  const { data } = await api.post("/users/recover-password", form, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return data;
}

export async function updateFormCompleted(data: { isFormCompleted: boolean }) {
  const resp = api.put("/users/integrations/type-form", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return resp;
}
